import $ from 'jquery'
import _ from 'lodash'
import text from './text'
import purify from './purify'
import notify from './notify'
import cookie from './cookie'
import csrf from './csrf'

function _serialize(form) {
  var $form = $(form)
  var restoreVals = []
  $form.find('input[type="password"]').prop('disabled', function (idx, oldVal) {
    var $input = $(this)
    if ($input.data('first-field-name') !== undefined || $.trim($input.val()).length === 0) {
      restoreVals.push({ k: $input, v: oldVal })
      console.log('disabling empty-password submission: ' + $input.prop('name'))
      return true
    }
    return undefined
  })
  $form.find('textarea.multitextarea').each(function () {
    var $this = $(this)
    restoreVals.push({ k: $this, v: $this.prop('disabled') })
    $this.prop('disabled', true)
  })
  _updateCkEditorBoxes($form)
  _updateMultilangs($form)
  var data = $form.serialize()

  $form.find('.sortable,.preselections-sortable').each(function () {
    var $l = $(this)
    var params = $l.find('li').map(function (idx, li) {
      var $li = $(li)
      return $l.data('parameter-name') + '[' + idx + ']=' + $li.data('id')
    }).get()
    var x = params.join('&')
    if (x.length > 0) {
      data = data + '&' + x
    }
  })
  $form.find('input.always-submit:disabled').each(function () {
    var $this = $(this)
    if (!_.isEmpty(data)) {
      data = data + '&'
    }
    var v = $this.is(':checkbox') ? $this.is(':checked') : encodeURIComponent($this.val())
    data += $this.prop('name') + '=' + v
  })
  _(restoreVals).each(function (e) {
    console.log('un-disabling ' + e.k.prop('name'))
    e.k.prop('disabled', e.v)
  })
  $('.dont-serialize [name]', $form).each(function (x, y) {
    data = data.replace(new RegExp('&' + $(y).attr('name') + '=[^&]*'), '')
  })
  return data
}

function _addErrorField(error) {
  if (!error.fieldName || error.fieldName == 'null') {
    return
  }
  var f
  if (error.fieldName == 'captcha') {
    f = $(document).find('.g-recaptcha')
  } else {
    f = $(document).find("[name='" + error.fieldName + "']")
  }
  if (f.size() != 1) {
    console.warn('Found ' + f.size() + ' matching fields for selector!')
    return
  }
  if (f.hasClass('multilang') && error.extraData !== undefined) {
    var lang = error.extraData
    console.log('multilang error found: ' + f.name + ' lang: ' + lang)
    var mle = f.parent().data('y')
    mle.markError(lang)
    _addValidationError(f.closest('form'), mle.getTextarea(lang), error.message)
  } else {
    _addValidationError(f.closest('form'), f, error.message)
  }
}

function _updateMultilangs(ctx) {
  $('.multi-lang-editor', ctx).each(function () {
    var me = $(this).data('y')
    if (me !== undefined && typeof me.onOffAll === 'function') {
      me.onOffAll()
    }
  })
}

function _updateCkEditorBoxes(ctx) {
  $('textarea.htmleditor', ctx).each(function () {
    var cke = $(this).data('ckeditor')
    if (cke !== undefined) {
      cke.updateElement()
    }
  })
}

function _clearFindEntries(table) {
  console.log('clearFindEntries')
  table.data('y').clear()
}

function _updateTable(what) {
  var $div = $(what).closest('.updateTable')
  if ($div.length > 0) {
    $('body').trigger('updateTable.begin', $div)
    console.log('updating target table')
    console.log($div)
    $div.load($div.data('url'), function () {
      installHandlers($div)
      $('body').trigger('updateTable.end', $div)
    })
  }
}

function _updateFinderOnDelete(what) {
  var $findTable = $(what).closest('.datatablez')
  var $row = $(what).closest('tr')
  if ($findTable.length > 0) {
    console.log('updating target datatablez ')
    console.log($findTable)
    $findTable.data('y').remove($row, false)
  }
}

function _updateDependents(what) {
  var _refresh = $(what).data('refresh')
  if (!_.isEmpty(_refresh)) {
    _(_refresh).each(function (e) {
      console.log(e)
      $('div.inline-page', $(e)).each(function (i, d) {
        console.log('Refreshing inline page')
        console.log(d)
        _loadInlinePage(d)
      })
      $('.updateTable', $(e)).each(function (i, d) {
        console.log('Refreshing table')
        console.log(d)
        _updateTable(d)
      })
    })
  }
}

function _saveErrors(response) {
  console.log('saving response')
  cookie.setJSON('response', response)
  cookie.set('response-set', Date.now())
}

function _loadAndShow() {
  var response = cookie.getJSON('response')
  if (typeof response == 'undefined') {
    console.log('there is no response saved')
    return
  }
  var old = (Date.now() - cookie.get('response-set'))
  console.log('cookie response was set ' + old + 'ms ago')
  _showMessages(response)
  cookie.rm('response')
  cookie.rm('response-set')
}

function _showMessages(response) {
  notify.clear()
  _(response.messages).each(function (e) {
    notify.message(e)
  })
  _(response.warnings).each(function (e) {
    notify.warning(e)
  })
  if (response.errors && response.errors.length > 0) {
    _(response.errors).each(function (e) {
      notify.error(e.message)
      _addErrorField(e)
    })
    if (typeof wiz !== 'undefined' && wiz !== null) {
      wiz.refresh()
      wiz.gotoError()
    }
  } else {
    if (typeof wiz !== 'undefined' && wiz !== null) {
      wiz.enableAll()
    }
  }
}

function _showCrudResponse(params) {
  return function (response) {
    console.log('crud response received')
    console.log(this)
    var $this = $(this)
    var newElem = $this.closest('.new_elem')

    var hasErrors = _hasErrors(response)
    var modal = $('#modal')
    var shouldCloseModal = (modal && modal.data('bs.modal') &&
      modal.data('bs.modal') != null &&
      modal.data('bs.modal').isShown)
    var $forms = [params.$form]
    if (params.$secondaryForm !== undefined) {
      $forms.push(params.$secondaryForm)
    }
    if (shouldCloseModal && newElem.length == 0) { //terrible hack, newElem has priority
      if (hasErrors) {
        _showMessages(response)
        _($forms).each(function ($form) {
          var autonod = $form.data('autonod')
          if (autonod !== undefined) {
            autonod.resetStatus()
          }
        })

        if (params.errorCallback !== undefined) {
          params.errorCallback(response)
        }
        if (typeof (grecaptcha) != 'undefined') {
          grecaptcha.reset()
        }
        console.log('re-enabling submit buttons')
        _($forms).each(function ($form) {
          $('.to-be-reenabled', $form)
            .prop('disabled', false)
            .removeClass('to-be-reenabled')
            .blur()
        })
        return
      }
      _updateTable(modal.data('who'))
      modal.modal('hide')
    }

    if (newElem.length > 0) {
      console.log('inside a new_elem')
      if (hasErrors) {
        _showMessages(response)
        _($forms).each(function ($form) {
          var autonod = $form.data('autonod')
          if (autonod !== undefined) {
            autonod.resetStatus()
          }
        })
        if (params.errorCallback !== undefined) {
          params.errorCallback(response)
        }
        console.log('re-enabling submit buttons')
        _($forms).each(function ($form) {
          $('.to-be-reenabled', $form)
            .prop('disabled', false)
            .removeClass('to-be-reenabled')
            .blur()
        })
        return
      }
      newElem.hide()
      _updateTable(newElem.data('who'))
    }

    if (((!shouldCloseModal && newElem.length == 0) || response.redirect_on_close === true) &&
      response.redirection !== undefined &&
      response.redirection != 'null') {
      console.log('Redirecting to: ' + response.redirection)
      _saveErrors(response)
      if (hasErrors && params.errorCallback !== undefined) {
        params.errorCallback(response)
      }
      window.location.href = response.redirection
      return
    }

    var $button = $this.data('button-pressed')
    var _refresh = $button === undefined ? $this.data('refresh') : $button.data('refresh')
    if (!_.isEmpty(_refresh)) {
      _(_refresh).each(function (e) {
        console.log(e)
        $('div.inline-page', $(e)).each(function (i, d) {
          console.log('Refreshing inline page')
          console.log(d)
          _loadInlinePage(d)
        })
      })
    }

    var $source = $button === undefined ?  $this : $button;
    if ($source.hasClass('trigger-event')) {
      $('body').trigger('crudResponse', $source);
    }

    _showMessages(response)
    _($forms).each(function ($form) {
      var autonod = $form.data('autonod')
      if (autonod !== undefined) {
        autonod.resetStatus()
      }
    })

    if (hasErrors && params.errorCallback !== undefined) {
      params.errorCallback(response)
    } else if (!hasErrors && params.successCallback !== undefined) {
      params.successCallback(response)
    }

    if (typeof (grecaptcha) != 'undefined') {
      grecaptcha.reset()
    }
    console.log('re-enabling submit buttons')
    _($forms).each(function ($form) {
      $('.to-be-reenabled', $form)
        .prop('disabled', false)
        .removeClass('to-be-reenabled')
        .blur()
    })
  }
}

function _handleAjaxError(jqXHR, statusText, errorThrown) {
  console.log('jqXHR status is: ' + jqXHR.status)
  if (jqXHR.status === 200) {
    return false
  }
  var errorMsg = text('error.ajax')
  var status = jqXHR.statusCode()
  if (jqXHR.status === 403) {
    errorMsg += ' ' + text('error.accessDenied')
    errorMsg += '<br/>'
    errorMsg += '<a class="" href="' + ctx + '">Login</a>'
  } else if (_.isEmpty(status.responseText) && status.statusText === 'error') {
    errorMsg += ' ' + text('error.connectionError')
  } else {
    errorMsg += _.isEmpty(errorThrown) ? '' : (' (' + errorThrown + ')')
  }
  if (typeof (grecaptcha) != 'undefined') {
    grecaptcha.reset()
  }
  notify.error(errorMsg)
  return true
}

function _showAjaxError(params) {
  return function (jqXHR, textStatus, errorThrown) {
    var $forms = []
    if (params && params.$form !== undefined) {
      $forms.push(params.$form)
    }
    if (params && params.$secondaryForm !== undefined) {
      $forms.push(params.$secondaryForm)
    }
    console.log('re-enabling submit buttons')
    _($forms).each(function ($form) {
      $('.to-be-reenabled', $form)
        .prop('disabled', false)
        .removeClass('to-be-reenabled')
        .blur()
    })
    _handleAjaxError(jqXHR, textStatus, errorThrown)
    if (params && params.errorCallback !== undefined) {
      params.errorCallback()
    }
  }
}

function _showButtonAjaxError($b) {
  return function (jqXHR, textStatus, errorThrown) {
    console.log('re-enabling button')
    console.log($b)
    $b.prop('disabled', false)
      .blur()
      .dropdown('toggle')
      .html(purify.button($b.data('original-html')))
    _handleAjaxError(jqXHR, textStatus, errorThrown)
  }
}

function _setButtonState($b, status) {
  console.log('changing button state to ' + status)
  console.log($b)
  var _html = $b.data(status + '-html')
  if (_html !== undefined) {
    $b.html(purify.button(_html))
  }
  var _class = $b.data(status + '-class')
  if (_class !== undefined) {
    $b.attr('class', _class)
  }
  var _disabled = $b.data(status + '-disabled')
  if (_disabled !== undefined) {
    $b.prop('disabled', _disabled)
  } else {
    $b.prop('disabled', false)
  }
  var _action = $b.data(status + '-action')
  if (_action !== undefined) {
    $b.data('action', _action)
    $b.data('href', '')
  }
  var _href = $b.data(status + '-href')
  if (_href !== undefined) {
    $b.data('href', _href)
    $b.data('action', '')
  }
}

function _showButtonResponse($b) {
  return function (response) {
    console.log('button response received')
    console.log($b)
    $b.blur()
    _.delay(function () {
      console.log('delayed')
      if (!_hasErrors(response)) {
        var _html = $b.data(response.result + '-html')
        if (_html !== undefined) {
          $b.html(purify.button(_html))
        }
        var _class = $b.data(response.result + '-class')
        if (_class !== undefined) {
          $b.attr('class', _class)
        }
        var _disabled = $b.data(response.result + '-disabled')
        if (_disabled !== undefined) {
          $b.prop('disabled', _disabled)
        } else {
          $b.prop('disabled', false)
        }
        var _action = $b.data(response.result + '-action')
        if (_action !== undefined) {
          $b.data('action', _action)
          $b.data('href', '')
        }
        var _href = $b.data(response.result + '-href')
        if (_href !== undefined) {
          $b.data('href', _href)
          $b.data('action', '')
        }
        var _resubmitForm = $b.data(response.result + '-resubmit-form')
        if (_resubmitForm === true) {
          console.log('resubmit form')
          $b.closest('form').submit()
        }
        _updateDependents($b[0])
        var _refreshView = $b.data('refresh-view')
        if (_refreshView === true) {
          var $row = $b.closest('tr')
          if (!_.isEmpty($row)) {
            var $table = $b.closest('table')
            var handler = $table.data('y')
            if (handler) {
              handler.update($row, false, function (response) {
                installHandlers($row.eq(0))
              })
            }
          }
        }
        var _removeView = $b.data('remove-view')
        if (_removeView === true) {
          var $row = $b.closest('tr')
          if (!_.isEmpty($row)) {
            var $table = $b.closest('table')
            var handler = $table.data('y')
            handler.remove($row, false)
          }
        }
      } else {

        $b.prop('disabled', false)
          .html(purify.button($b.data('original-html')))
          .data('action', $b.data('original-action'))
        _showMessages(response)
      }
    }, 500)

    var modal = $('#modal')
    var shouldCloseModal = (modal && modal.data('bs.modal') &&
      modal.data('bs.modal') != null &&
      modal.data('bs.modal').isShown)
    if (!shouldCloseModal && $b.data('redirect') === true &&
      response.redirection !== undefined &&
      response.redirection != 'null' &&
      $b.closest('table.datatablez').length === 0) {
      console.log('Redirecting to: ' + response.redirection)
      _saveErrors(response)
      window.location.href = response.redirection
      return
    }
  }
}

function _showSelfRemoveButtonResponse($b) {
  return function (response) {
    console.log('self-remove button response received')
    console.log($b)
    $b.blur()
    if (_hasErrors(response)) {
      _showMessages(response)
      return
    } else {
      console.log('Removing the <li>')
      $b.closest('li').remove()
    }
  }
}

function _showFindResponseErrors(form, table) {
  return function (response) {
    console.log('find response received')

    if (response.errors.length !== 0) {
      _showMessages(response)
    } else {
      installHandlers(table)
      var empty = (response.data.recordsTotal === '0')
      if (empty) {
        console.log('Table ' + table.attr('id') + ' is empty')
        table.closest('.hide_if_table_empty').hide()
      } else {
        console.log('Table ' + table.attr('id') + ' is not empty')
        table.closest('.show_if_table_not_empty').show()
      }
    }
    _updateFormInitialData(form)
    $('input[type="submit"]', form).blur()
    _finders_--
    console.debug('_finders_=' + _finders_)
  }
}

function _showFindResponse(form, table) {
  return function (response) {
    console.log('find response received')

    if (response.errors.length !== 0) {
      _(response.errors).each(function (e) {
        console.log(e)
        notify.error(e.message)
        _addErrorField(e)
      })
    } else {
      _clearFindEntries(table)
      var handler = table.data('y')
      handler.add(response.data.data).refresh().show()
      console.log('table loaded')
      $('.comment-amount', table).each(function (e) {
        var _e = $(this)
        var _table = _e.closest('.offer-table')
        var _dt = _table.data('y')
        var _row = _e.closest('tr')
        var _id = _dt.row(_row).data().id
        if (_e.data('closed') == true && cookie.get(_id + '-status') === undefined) {
          _e.closest('.row').nextAll().hide()
          cookie.set(_id + '-status', 'closed')
        }
      })

    }
    $('input[type="submit"]', form).blur()
    _finders_--
    console.debug('_finders_=' + _finders_)
  }
}

function _updateOnDelete(response) {
  _showMessages(response)
  if (_hasErrors(response)) {
    return
  }

  _updateTable(this)
  _updateFinderOnDelete(this)
  _updateDependents(this)
}

function _hasErrors(response) {
  return response.errors.length !== 0
}

function _addValidationError($form, element, message, err) {
  var multilang = element.hasClass('multitextarea') || element.hasClass('multitext')
  var captcha = element.hasClass('g-recaptcha')
  var p
  if (multilang) {
    var lang = element.data('language')
    var mle = element.parents('.multi-lang-editor').data('y')
    mle.markError(lang)
    p = element.parents('.tab-pane')
  } else {
    p = element.parents('.form-group')
  }
  p.addClass('has-error').addClass('has-feedback')

  if (err) {
    err.remove()
  }
  err = $('<span/>', {
    html: purify.block(message),
    class: 'help-block ' + 'autonod_error',
  })

  var type = element.attr('type');
  if (type === 'checkbox' || type === 'radio') {
    element.parent().parent().append(err)
  } else {
    element.parent().append(err)
  }

  if (typeof wiz !== 'undefined' && wiz !== null) {
    wiz.refresh()
  }
  if ($form.hasClass('validation-blocks-submit') === true) {
    $form.find('.form-submit').prop('disabled', 'disabled')
  }
  return err
}

function _removeValidationError($form, element, err, removeGlobal) {
  if (err) {
    err.remove()
  }

  var multilang = element.hasClass('multitextarea') || element.hasClass('multitext')
  var p
  if (multilang) {
    var lang = element.data('language')
    if (removeGlobal) {
      var mle = element.parents('.multi-lang-editor').data('y')
      mle.markOk(lang)
      p = element.parents('.tab-pane')
    }
  } else {
    p = element.parents('.form-group')
  }

  if (removeGlobal && p.hasClass('has-error')) {
    p.removeClass('has-error').removeClass('has-feedback')
    p.find('.autonod_error').remove()
    if ($form.hasClass('validation-blocks-submit') === true &&
      $form.find('.has-error').length == 0) {
      $form.find('.form-submit').prop('disabled', false)
    }
  }

  if (typeof wiz !== 'undefined' && wiz !== null) {
    wiz.refresh()
  }
}

function _loadInlinePage(sel) {
  var $this = $(sel)
  if ($this.length == 0) {
    return
  }
  console.log('found inline-page: ' + $this.data('page'))
  $this.removeClass('loaded')
  $this.load($this.data('page'),
    'pageStyle=popup', function () {
      console.log('loading completed inline-page: ' + $this.data('page'))
      installHandlers($this)
      console.log($this)
      $('body').trigger('inlinePageLoaded', $this.eq(0))
      $this.addClass('loaded')
    }
  )
}

function _initCheckboxHideOnChange(e) {
  var $source = $(e)
  if ($source.hasClass('hideonchange')) {
    var $when = $source.data('hideonvalues')
    var targets = $source.data('hideonchange')

    if (!_(targets).isEmpty()) {
      if (($when !== undefined && _($when).includes($source.prop('checked')))) {
        _(targets).each(function (e) {
          var $target = $('[name="' + e + '"]')
          if ($target.length == 0) {
            return true
          }
          var targetSel = $target[0].selectize
          if (targetSel === undefined) {
            $target.prop('disabled', 'disabled')
          } else {
            targetSel.disable()
          }
        })
      }
    }

    $source.change(function (evt) {
      if (($when !== undefined && _($when).includes($source.prop('checked')))) {
        _(targets).each(function (e) {
          var $target = $('[name="' + e + '"]')
          if ($target.length == 0) {
            return true
          }
          var targetSel = $target[0].selectize
          if (targetSel === undefined) {
            $target.prop('disabled', 'disabled')
          } else {
            targetSel.disable()
          }
          $target.trigger('change')
        })
      } else {
        _(targets).each(function (e) {
          var $target = $('[name="' + e + '"]')
          if ($target.length == 0) {
            return true
          }
          var targetSel = $target[0].selectize
          if (targetSel === undefined) {
            $target.prop('disabled', false)
          } else {
            targetSel.enable()
          }
        })
      }
    })
  }
}

function _initSelectHideOnChange(e) {
  var $source = $(e)
  var sourceSel = $source[0].selectize
  if ($source.hasClass('hideonchange')) {
    var $when = $source.data('hideonvalues')
    var targets = $source.data('hideonchange')

    if (!_(targets).isEmpty()) {
      var _value = sourceSel.getValue()
      if ($when !== undefined && (($when == '+' && !_.isEmpty(_value)) ||
        _($when).includes(_value))) {
        _(targets).each(function (e) {
          var $target = $('[name="' + e + '"],[data-param-name="' + e + '"]')
          if ($target.length == 0) {
            return
          }
          var targetSel = $target[0].selectize
          if ($target.attr('data-param-name')) {
            $target.closest('.updateTable').hide()
          } else if (targetSel === undefined) {
            $target.prop('disabled', 'disabled')
          } else {
            targetSel.disable()
          }
        })
      }
    }

    sourceSel.on('change', function (value) {
      var _value = sourceSel.getValue()
      if ($when !== undefined && (($when == '+' && !_.isEmpty(_value)) ||
        _($when).includes(_value))) {
        _(targets).each(function (e) {
          var $target = $('[name="' + e + '"],[data-param-name="' + e + '"]')
          if ($target.length == 0) {
            console.warn('[name=' + e + '] was not found')
            return
          }
          var targetSel = $target[0].selectize
          if ($target.attr('data-param-name')) {
            $target.closest('.updateTable').hide()
          } else if (targetSel === undefined) {
            $target.prop('disabled', 'disabled')
          } else {
            targetSel.disable()
          }
          $target.trigger('change')
        })
      } else {
        _(targets).each(function (e) {
          var $target = $('[name="' + e + '"],[data-param-name="' + e + '"]')
          if ($target.length == 0) {
            console.warn('[name=' + e + '] was not found')
            return
          }
          var targetSel = $target[0].selectize
          if ($target.attr('data-param-name')) {
            $target.closest('.updateTable').show()
          } else if (targetSel === undefined) {
            $target.prop('disabled', false)
          } else {
            targetSel.enable()
          }
        })
      }
    })
  }
}

function _updateFormInitialData(form) {
  console.log('_updateFormInitialData')
  var d = _serialize(form)
  $(form).data('serial', d)
}

function _handlePopup($b, url=null) {
  $b.dropdown('toggle')
  var target = $b.is('a') ? $b.prop('href') : $b.val()
  if (url != null) {
    target = url
  }
  var big = $b.hasClass('big-popup')
  var $modal = $('#modal')
  var $dialog = $modal.find('.modal-dialog')
  var $modalContent = $dialog.find('.modal-content')
  $modalContent.empty()
  if (big && !$dialog.hasClass('modal-lg')) {
    $dialog.addClass('modal-lg')
  } else if (!big && $dialog.hasClass('modal-lg')) {
    $dialog.removeClass('modal-lg')
  }
  $modal.modal({
    backdrop: 'static',
  }).one('show.bs.modal', function (e) {
    console.log('loading modal url: ' + target)
    $modalContent.load(
      target,
      function (responseText, textStatus, jqXHR) {
        console.log('modal content received')
        if (_handleAjaxError(jqXHR, textStatus, undefined)) {
          $modal.modal('hide')
        } else {
          installHandlers($(this))
        }
      }
    )
  }).one('hidden.bs.modal', function (e) {
    if (url != null) {
      console.log('this is a custom-js thingie')
      _updateTable($b)
    }
    console.log('modal hidden')
    $('modalContent').empty()
    $(this).data('bs.modal', null);
  }).data('who', $b).modal('show')
}

function _handlePopin($b) {
  console.log('handling popin')
  var target = $b.is('a') ? $b.prop('href') : $b.val()
  if ($b.hasClass('edit')) {
    // version for the updates inside the table
    newElem = $b.closest('td').find('.new_elem')
    console.log(newElem)
    if (newElem.is(':visible')) {
      newElem.hide()
    } else {
      $b.closest('table').find('.new_elem').hide()
      $.get(target, {},
        function (data, status, xhr) {
          newElem.data('who', $b)
          newElem.data('text', $b.text())
          newElem.show()
          $('.inside', newElem).empty().append(data)
          installHandlers(newElem)
        })
    }
  } else {
    // version for the create outside the table
    var newElem = $b.next('.new_elem')
    if (newElem.is(':visible')) {
      newElem.hide()
      $b.text(newElem.data('text'))
      $b.addClass('plus')
    } else {
      $.get(target, {},
        function (data, status, xhr) {
          newElem.data('who', $b)
          newElem.data('text', $b.text())
          $b.text(text('cancel.add'))
          $b.removeClass('plus')
          newElem.show()
          $('.inside', newElem).empty().append(data)
          installHandlers(newElem)
        })
    }
  }
}

export default {
  serialize: _serialize,
  addErrorField: _addErrorField,
  clearFindEntries: _clearFindEntries,
  saveErrors: _saveErrors,
  loadAndShow: _loadAndShow,
  showMessages: _showMessages,
  showCrudResponse: _showCrudResponse,
  handleAjaxError: _handleAjaxError,
  showAjaxError: _showAjaxError,
  showButtonAjaxError: _showButtonAjaxError,
  setButtonState: _setButtonState,
  showButtonResponse: _showButtonResponse,
  showSelfRemoveButtonResponse: _showSelfRemoveButtonResponse,
  showFindResponseErrors: _showFindResponseErrors,
  showFindResponse: _showFindResponse,
  updateOnDelete: _updateOnDelete,
  hasErrors: _hasErrors,
  addValidationError: _addValidationError,
  removeValidationError: _removeValidationError,
  loadInlinePage: _loadInlinePage,
  initCheckboxHideOnChange: _initCheckboxHideOnChange,
  initSelectHideOnChange: _initSelectHideOnChange,
  updateFormInitialData: _updateFormInitialData,
  handlePopup: _handlePopup,
  handlePopin: _handlePopin,
}
